import { TPosition } from 'src/service/scene/types';

export function calculateAngleOX(vector1: TPosition, vector2: TPosition, THREE: any) {
  const v1 = new THREE.Vector3(vector1.x, 0, vector1.z);
  const v2 = new THREE.Vector3(vector2.x, 0, vector2.z);

  const direction = new THREE.Vector3().subVectors(v2, v1);
  return Math.atan2(direction.x, direction.z);
}

export function calculateMidpoint(point1: TPosition, point2: TPosition, THREE: any) {
  const midpoint = new THREE.Vector3(
    (point1.x + point2.x) / 2,
    (point1.y + point2.y) / 2,
    (point1.z + point2.z) / 2,
  );
  return midpoint;
}
